import { ReactNode } from 'react';

/**
 * Function to interpolate ReactNodes into a string.
 *
 * @param base The base string to add ReactNodes to (e.g {1} ... {2}).
 * @param additions The ReactNodes to be added.
 *
 * @returns A ReactNode with the base string interpolated with the desired additions.
 */
export const interpolateNodes = (base: string, ...additions: ReactNode[]) => {
	let parts: ReactNode[] = base.split(/\{\d+\}/);

	// parts will always have 1 extra
	if (additions.length !== parts.length - 1) {
		console.log(
			'interpolation error, incorrect number of additional nodes supplied.'
		);
		return base;
	}

	let additionCounter = 0;

	additions?.forEach((addition, index) => {
		additionCounter++;
		const insertPosition = additionCounter + index;

		if (insertPosition > parts.length) return;

		parts.splice(insertPosition, 0, addition);
	});

	return <>{parts.map((part) => part)}</>;
};
